import React from 'react'
import {makeStyles} from '@mui/styles'
import Grid from '@mui/material/Grid'
import TextInput from '../TextInput'
import MultilineTextInput from '../MultilineTextInput'
import SelectInput from '../SelectInput'
import {CATEGORY_LABELS} from './ServiceRequestConstants'
import {convertKeyLabelMapIntoSelectOptions} from '../../Utils/objectUtil'
import {spaceMedium} from '../../assets/styles/spacing'
import {rxrPrimaryColor} from '../../assets/styles/color'
import {fontSizeMediumLarge, lightFontWeight} from '../../assets/styles/typography'
import SearchResident from '../SearchResident'
import CustomCheckbox from '../CustomCheckbox'
import ImageGallerySelector from '../ImageGallerySelector'

const selectOptions = convertKeyLabelMapIntoSelectOptions(CATEGORY_LABELS)

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  formRow: {
    marginBottom: spaceMedium,
  },
  attachmentTitle: {
    color: rxrPrimaryColor,
    fontSize: fontSizeMediumLarge,
    fontWeight: lightFontWeight,
  },
}))

function ServiceRequestForm(props) {
  const classes = useStyles()

  const isViewingExisting = !!props.id

  return (
    <div className={classes.root}>
      <Grid container spacing={3} className={classes.formRow}>
        <Grid item xs={12}>
          <SearchResident
            value={props.residentId}
            disabled={isViewingExisting}
            isRequired={true}
            onSelectResident={r => props.updateForm({residentId: r.id})}
            error={props.invalidItems.includes('residentId')}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} className={classes.formRow}>
        <Grid item xs={12}>
          <SelectInput
            disabled={isViewingExisting}
            label={'Category'}
            value={props.category}
            onChange={val => props.updateForm({category: val})}
            options={selectOptions}
            isRequired={true}
            error={props.invalidItems.includes('category')}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} className={classes.formRow}>
        <Grid item xs={12}>
          <CustomCheckbox
            isDisabled={isViewingExisting}
            label={'Has permission to enter'}
            isChecked={props.hasPermissionToEnter}
            onChange={val => props.updateForm({hasPermissionToEnter: val})}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} className={classes.formRow}>
        <Grid item xs={12}>
          <MultilineTextInput
            isDisabled={isViewingExisting}
            rows={6}
            label="Description"
            placeholder=""
            maxLength={1000}
            onChange={val => props.updateForm({description: val})}
            value={props.description}
            isRequired={true}
            error={props.invalidItems.includes('description')}
          />
        </Grid>
      </Grid>

      {isViewingExisting && (
        <React.Fragment>
          <Grid container spacing={3} className={classes.formRow}>
            <Grid item xs={12}>
              <TextInput isDisabled={true} label="Work Order ID" placeholder="" value={props.yardiServiceRequestId} />
            </Grid>
          </Grid>
          <Grid container spacing={3} className={classes.formRow}>
            <Grid item xs={12}>
              <div className={classes.attachmentTitle}>Attachments</div>
              {props.attachments?.length ? (
                <div className={classes.attachmentsContainer}>
                  <ImageGallerySelector value={props.attachments} isViewOnly />
                </div>
              ) : (
                <div>No attachments</div>
              )}
            </Grid>
          </Grid>
          <Grid container spacing={3} className={classes.formRow}>
            <Grid item xs={12}>
              <MultilineTextInput
                isDisabled
                rows={6}
                label="Technician notes"
                value={props.technicianNotes}
                helperText="For office use only."
              />
            </Grid>
          </Grid>
        </React.Fragment>
      )}
    </div>
  )
}

export default ServiceRequestForm
